//文字コードはutf-8

import { initHamburgerMenu } from './modules/hamburger.js';
import { initScrollReveal } from './modules/scrollReveal.js';
import { initKvIntro } from './modules/kvIntro.js';
import { initMarquee } from './modules/marquee.js';
import { initCountUp } from './modules/countUp.js';
import { initGridScroll } from './modules/gridScroll.js';

// 既存
initHamburgerMenu();

// 50周年記念ページ用アニメーション群
initKvIntro();        // KV のロード後フェードインチェーン
initScrollReveal();   // [data-reveal] の汎用スクロールリビール
initMarquee();        // .topFlowSlide__list の無限横スクロール
initCountUp();        // 寄付金額の数値カウントアップ
initGridScroll();     // .topGridSlide の 3 カラム縦無限スクロール（PC のみ）
